import type { RouteObject } from 'react-router-dom'

// CHANGE-070: the growth pages moved into the staff app (features/staff/routes.tsx). These components stay, shown on
// /staff/outreach and /staff/funnel.
export const routes: RouteObject[] = []
